"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireDefault(require("react"));
require("./TaskScaleBuilder.css");
require("./MusicEditor.css");
var _DesignComponents = require("../DesignComponents/DesignComponents");
var _CompletedContext = require("../CompletedContext");
var _MusicEditor2 = _interopRequireDefault(require("./MusicEditor"));
var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback/ModalFeedback"));
var _questionMarkIcon = _interopRequireDefault(require("../assets/question-mark-icon.png"));
var _FeedbackIcon = _interopRequireDefault(require("../FeedbackIcon/FeedbackIcon"));
var _TaskChordBuilder = require("./TaskChordBuilder");
var TaskScaleBuilder = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TaskScaleBuilder, _React$Component);
  var _super = (0, _createSuper2.default)(TaskScaleBuilder);
  function TaskScaleBuilder(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TaskScaleBuilder);
    _this = _super.call(this, props);
    _this.state = props.state || {};
    if (!_this.state.initialized) {
      _this.state.initialized = true;
      // Initial state is set here, since the constructor can be called more than once.
      _this.state.completed = false;
      _this.state.showAnswer = false;
      _this.state.notation = _this.props.notation || _this.props.musicInitial || _this.props.notation_initial || "zzzzzzzz";
      _this.state.musicInitial = _this.props.musicInitial;
      _this.state.answerState = {};
      _this.state.showInfo = false;
    }
    _this.state.precursor = _this.props.musicConfiguration.split(';').join('\n') + '\n';
    _this.state.correctAnswer = _this.props.correct || _this.props.answers.find(function (a) {
      return a.correct;
    }).answer;
    _this.musiceditor = /*#__PURE__*/_react.default.createRef();
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.submitScale = _this.submitScale.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderResetButton = _this.renderResetButton.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderSubmitButton = _this.renderSubmitButton.bind((0, _assertThisInitialized2.default)(_this));
    _this.changeAnswerState = _this.changeAnswerState.bind((0, _assertThisInitialized2.default)(_this));
    _this.showInfo = _this.showInfo.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(TaskScaleBuilder, [{
    key: "changeAnswerState",
    value: function changeAnswerState(newAnswerState) {
      this.setState({
        answerState: newAnswerState
      });
    }
  }, {
    key: "arraysAreIdentical",
    value: function arraysAreIdentical(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;
      for (var i = 0, len = arr1.length; i < len; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }
      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
      if (prevprops.musicInitial !== this.props.musicInitial) {
        this.state.notation = this.props.notation || this.props.musicInitial || this.props.notation_initial || "zzzzzzzz";
      }
      this.state.precursor = this.props.musicConfiguration.split(';').join('\n') + '\n';
      this.state.correctAnswer = this.props.correct || this.props.answers.find(function (a) {
        return a.correct;
      }).answer;
    }
  }, {
    key: "markStaffLineAndSpaces",
    value: function markStaffLineAndSpaces() {
      var removeAnnotationsRegex = /\".*?\"/g;
      var answerString = this.state.notation.replace(removeAnnotationsRegex, "").replaceAll("|", "");
      var answers = (0, _TaskChordBuilder.splitNotation)(answerString); // todo: apply this in music editor

      var correctAnswers = (0, _TaskChordBuilder.splitNotation)(this.state.correctAnswer.replace(removeAnnotationsRegex, "").replaceAll("|", ""));
      var newAnswerState = {};
      for (var i = 0; i < answers.length; ++i) {
        var _ref;
        newAnswerState["".concat(i)] = (_ref = answers[i] === correctAnswers[i]) !== null && _ref !== void 0 ? _ref : false;
      }
      this.setState({
        answerState: newAnswerState
      });
    }
  }, {
    key: "submitScale",
    value: function submitScale() {
      if (this.props.answers) {
        var found = false;
        var _iterator = (0, _createForOfIteratorHelper2.default)(this.props.answers),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var answer = _step.value;
            if (this.state.notation === answer.answer) {
              found = true;
              this.markStaffLineAndSpaces();
              this.setState({
                completed: answer.correct,
                showAnswer: false,
                correct: answer.correct,
                showFeedback: true,
                showNag: this.state.showAnswer,
                feedback: answer.feedback
              });
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (!found) {
          this.markStaffLineAndSpaces();
          this.setState({
            completed: false,
            showAnswer: this.state.correct !== undefined,
            correct: false,
            feedback: this.props.feedbackIncorrect,
            showFeedback: true,
            showNag: this.state.showAnswer
          });
        }
      } else {
        this.markStaffLineAndSpaces();
        if (this.state.notation === this.state.correctAnswer) {
          this.setState({
            showAnswer: false,
            correct: true,
            completed: true,
            notation: this.state.notation,
            showFeedback: true,
            feedback: this.props.feedbackCorrect
          });
        } else {
          this.setState({
            showAnswer: this.state.correct !== undefined,
            correct: false,
            completed: false,
            showFeedback: true,
            showNag: this.state.showAnswer,
            feedback: this.props.feedbackIncorrect
          });
        }
      }
    }
  }, {
    key: "onChange",
    value: function onChange(newNotation) {
      this.setState({
        notation: newNotation
      });
    }
  }, {
    key: "renderResetButton",
    value: function renderResetButton(_onClick) {
      var _this3 = this;
      return /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
        variant: "outline",
        color: "white",
        disabled: this.state.correct || this.state.notation === this.state.musicInitial,
        style: {
          margin: "0px 12px"
        },
        className: this.state.correct || this.state.notation === this.state.musicInitial ? "music-function-button-disabled" : "music-function-button-enabled",
        onClick: function onClick() {
          _onClick();
          var newNotation = _this3.state.musicInitial;
          _this3.musiceditor.current.setState({
            accidental: ""
          });
          _this3.setState({
            notation: newNotation,
            reset: true,
            answerState: {}
          });
        }
      }, "Reset Staff");
    }
  }, {
    key: "renderSubmitButton",
    value: function renderSubmitButton(secondButton) {
      return /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
        variant: "dark",
        disabled: this.state.correct || this.state.notation === this.state.musicInitial,
        style: {
          float: "right"
        },
        className: this.state.correct || this.state.notation === this.state.musicInitial ? "music-function-button-disabled" : "music-function-button-enabled" + (secondButton ? " second-submit" : ""),
        onClick: this.submitScale
      }, "Submit");
    }
  }, {
    key: "showInfo",
    value: function showInfo() {
      this.setState({
        showInfo: true,
        showFeedback: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this,
        _this$props$zoom,
        _this$props$zoom2;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "task task-scale-builder",
        style: this.props.style
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "scale-instruction"
      }, "Select a location to add notes to the staff by using the up or down arrow keys to move between the lines and spaces, and the left or right arrow keys to move between the beats. Use the spacebar or return key to add, delete, or modify a note at the cursor location.\xA0", /*#__PURE__*/_react.default.createElement("span", {
        className: "sr-only"
      }, "Use the hot key: ", navigator.userAgent.toLowerCase().indexOf('win') >= 0 ? " Alt " : " Command ", "-Shift-1, to get a full read out of the current score."), /*#__PURE__*/_react.default.createElement("div", {
        role: "button",
        style: {
          display: "inline-block"
        },
        tabIndex: "0",
        "aria-label": "Explanation of symbols",
        onClick: this.showInfo,
        onKeyDown: function onKeyDown(e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopPropagation();
            _this4.showInfo();
          }
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        style: {
          width: "20px",
          height: "20px",
          marginBottom: "4px",
          marginLeft: "4px"
        },
        src: _questionMarkIcon.default
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "scale-builder-container",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement(_MusicEditor2.default, Object.assign({
        ref: this.musiceditor
      }, this.props, this.state, {
        rangeLower: this.props.rangeLower,
        rangeUpper: this.props.rangeUpper,
        addClasses: true,
        addHotspots: !this.state.completed,
        monophonic: true,
        accidentals: true,
        millisecondsPerMeasure: this.props.musicDuration,
        zoom: (_this$props$zoom = this.props.zoom) !== null && _this$props$zoom !== void 0 ? _this$props$zoom : 2,
        precursor: this.state.precursor,
        notation: this.state.notation,
        perNoteAnnotationAltText: this.props.perNoteAnnotationAltText,
        correctPitches: this.state.answer,
        onChange: this.onChange,
        renderResetButton: this.renderResetButton,
        renderSubmitButton: this.renderSubmitButton,
        completed: this.state.completed,
        showAnswer: this.state.showAnswer,
        scaleAnswerState: this.state.answerState,
        changeAnswerState: this.changeAnswerState
      }))), this.state.showAnswer && !this.state.completed && /*#__PURE__*/_react.default.createElement("div", {
        className: "scale-builder-container",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("p", {
        style: {
          fontSize: "12px",
          fontWeight: "bold",
          fontStretch: "normal",
          fontStyle: "italic",
          lineHeight: "1.83",
          letterSpacing: "normal",
          textAlign: "center",
          color: "#63768a",
          margin: "24px 0px 0px 0px"
        }
      }, "The correct answer is shown below. Update and submit the correct answer to move on."), /*#__PURE__*/_react.default.createElement(_MusicEditor2.default, Object.assign({
        ref: this.musiceditor,
        staffRef: this.staffRef
      }, this.props, this.state, {
        rangeLower: this.props.rangeLower,
        rangeUpper: this.props.rangeUpper,
        addClasses: true,
        addHotspots: !this.state.completed,
        hintMode: true,
        monophonic: true,
        millisecondsPerMeasure: this.props.musicDuration,
        zoom: (_this$props$zoom2 = this.props.zoom) !== null && _this$props$zoom2 !== void 0 ? _this$props$zoom2 : 2,
        precursor: this.state.precursor,
        notation: this.state.correctAnswer,
        answer: this.state.answer,
        onChange: function onChange() {},
        renderSubmitButton: this.renderSubmitButton,
        completed: this.state.completed,
        showAnswer: this.state.showAnswer
      }))), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
        show: this.state.showFeedback,
        correct: this.state.showInfo ? undefined : this.state.correct,
        onHide: function onHide() {
          _this4.setState({
            showFeedback: false,
            showInfo: false
          });
          var secondSubmitButton = document.getElementsByClassName("second-submit");
          if (secondSubmitButton.length > 0) {
            setTimeout(function () {
              secondSubmitButton[0].focus();
            }, 10);
          }
        }
      }, this.state.showInfo ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "These icons are used to differentiate answer feedback:", /*#__PURE__*/_react.default.createElement("ul", {
        style: {
          listStyle: 'none',
          marginTop: "10px"
        }
      }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_FeedbackIcon.default, {
        iconSize: "16px"
      }), " Incorrect"), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_FeedbackIcon.default, {
        correct: true,
        iconSize: "16px"
      }), " Correct"))) : this.state.feedback));
    }
  }]);
  return TaskScaleBuilder;
}(_react.default.Component);
TaskScaleBuilder.contextType = _CompletedContext.CompletedContext;
var _default = exports.default = TaskScaleBuilder;